<script lang="ts">
    import SlideOver from "../layout/SlideOver.svelte";
    import RadioSelect from "../molecules/RadioSelect.svelte";
    import LinearProgress from "@smui/linear-progress";
    import MaintenancePreview from "./MaintenancePreview.svelte";
    import type {IMaintenanceData} from "../../data";

    let order = {
        overlay: false,
        options: [],
        active: 'vendidos'
    }

    export let data: Array<IMaintenanceData>;
    export let loading: boolean;

    function orderBy() {
        order.overlay = false;
    }
</script>

<section>
    <!--div class="grid-2 py-ii border-bottom buttons">
        <div class="box sx-ii py-ii pointer" on:click="{()=> order.overlay = true}">
            <img height="15" src="/static/storefront/pix/icons/ordenar.svg" alt="Ordenar">
            <span>Ordenar</span>
        </div>
    </div-->
    <div class="container py-15">
        <div class="grid-2 gap-1 m:grid-4 m:gap-15">
            {#each data as item}
                <MaintenancePreview data={item}/>
            {:else}
                {#if loading}
                    <div class="text-c loading-bar">
                        <LinearProgress class="w-100" indeterminate/>
                        <small>Cargando...</small>
                    </div>
                {:else}
                    No hay items disponibles
                {/if}
            {/each}
        </div>
    </div>
    <SlideOver bind:open={order.overlay}>
        <h2 class="mb-2">Todo para tu Nissan</h2>
        <RadioSelect options="{order.options}" bind:active="{order.active}"/>
        <div slot="actions">
            <div class="box-r sx-ii">
                <div class="btn" on:click={()=> order.overlay = false}>CANCELAR</div>
                <div class="btn solid accent" on:click={orderBy}>ORDERNAR</div>
            </div>
        </div>
    </SlideOver>
</section>